export default __webpack_public_path__ + "assets/webgl/picking-20.a8fea970.glb";